import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import client from "@/lib/api";
import Reveal from "@/components/Reveal";
import SEO from "@/components/SEO";
import ParticleField from "@/components/ParticleField";

export default function Careers() {
  const [roles, setRoles] = useState([]);
  useEffect(() => {
    client.get("/careers").then(({ data }) => setRoles(data)).catch(() => {});
  }, []);

  return (
    <div>
      <SEO title="Careers — Build What Doesn't Exist Yet | ImJove Tech" description="Join ImJove Tech and help build the future across engineering, AI, design, product and more." />
      <section className="relative overflow-hidden pb-16 pt-40">
        <ParticleField className="absolute inset-0 z-0" density={40} />
        <div className="radial-fade absolute inset-0" />
        <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-12">
          <Reveal>
            <p className="font-mono2 text-xs uppercase tracking-brand text-gold-light">Careers</p>
            <h1 className="mt-4 max-w-4xl font-display text-5xl font-bold tracking-tighter text-white sm:text-7xl">
              Build what <span className="text-gold-gradient">doesn't exist yet.</span>
            </h1>
            <p className="mt-6 max-w-2xl font-body text-lg text-white/55">
              We're assembling a team of builders across engineering, artificial intelligence, design, product, and more.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-28">
        <div className="mx-auto max-w-[1000px] px-6 md:px-12">
          <div className="space-y-4">
            {roles.map((r, i) => (
              <Reveal key={r.id} delay={i * 0.05}>
                <div data-testid={`career-${i}`} className="card-hover flex flex-col gap-4 rounded-2xl border border-white/10 bg-ink-800 p-7 md:flex-row md:items-center md:justify-between">
                  <div>
                    <span className="font-mono2 text-[10px] uppercase tracking-widest text-gold-light">{r.department}</span>
                    <h3 className="mt-1.5 font-display text-2xl font-semibold text-white">{r.title}</h3>
                    <p className="mt-2 font-body text-sm text-white/55">{r.description}</p>
                    <div className="mt-3 flex flex-wrap gap-4 font-mono2 text-[11px] uppercase tracking-widest text-white/40">
                      <span className="inline-flex items-center gap-1.5"><MapPin size={12} /> {r.location}</span>
                      <span>{r.type}</span>
                    </div>
                  </div>
                  {r.apply_url ? (
                    <a href={r.apply_url} target="_blank" rel="noreferrer" className="btn-gold inline-flex shrink-0 items-center gap-2 rounded-full px-6 py-3 font-mono2 text-[11px] font-semibold uppercase tracking-widest">
                      Apply <ArrowUpRight size={14} />
                    </a>
                  ) : (
                    <Link to="/contact" className="btn-ghost inline-flex shrink-0 items-center gap-2 rounded-full px-6 py-3 font-mono2 text-[11px] uppercase tracking-widest">
                      Apply <ArrowUpRight size={14} />
                    </Link>
                  )}
                </div>
              </Reveal>
            ))}
          </div>
          {roles.length === 0 && (
            <p className="font-body text-white/40">No open positions right now — reach out anyway via <Link to="/contact" className="text-gold-light">Contact</Link>.</p>
          )}
        </div>
      </section>
    </div>
  );
}
